import { gql } from '@apollo/client';

export const createFacilityNotepadEntry = gql`
  mutation createFacilityNotepadEntry($input: CreateFacilityNotepadEntry) {
    createFacilityNotepadEntry(input: $input) {
      id
      categoryId
      note
      archived
      createdBy
      createdAt
      Category {
        id
        name
      }
    }
  }
`;
